import React from 'react';
export function KeyHighlights() {
  const highlights = ['Premium open plan workspace across 485 sqm', 'Floor-to-ceiling glazing with abundant natural light', "Surrounded by Melbourne's leading creative and technology businesses"];
  return <section className="bg-brand-black py-16 md:py-32 px-5 md:px-12 lg:px-24" data-id="element-48">
      <div className="max-w-7xl mx-auto flex flex-col md:flex-row gap-10 md:gap-24" data-id="element-49">
        <div className="md:w-1/3" data-id="element-50">
          <p className="font-mono uppercase tracking-label text-brand-grey text-xs mb-5 md:mb-6" data-id="element-51">
            THE PROPERTY.
          </p>
          <h2 className="font-display text-4xl md:text-6xl uppercase text-brand-white leading-[0.9]" data-id="element-52">
            <span className="block" data-id="element-53">KEY</span>
            <span className="block" data-id="element-54">HIGHLIGHTS.</span>
          </h2>
        </div>

        <div className="md:w-2/3 flex flex-col" data-id="element-55">
          {highlights.map((highlight, index) => <div key={index} className="border-b border-brand-gold/40 py-5 md:py-6 first:pt-0 last:border-b-0" data-id="element-56">
              <div className="flex items-start" data-id="element-57">
                <span className="text-brand-gold mr-3 md:mr-4 mt-0.5" data-id="element-58">—</span>
                <p className="font-body text-brand-white/90 text-base md:text-xl font-light leading-relaxed" data-id="element-59">
                  {highlight}
                </p>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}